/** Marks a procedure whose due date has passed. Shared by the procedure tables and the Overall Status board. */
export function OverduePill() {
  return (
    <span className='inline-flex shrink-0 items-center rounded-full border border-rose-200 bg-rose-50 px-1.5 py-px text-[10px] font-medium text-rose-700'>
      Overdue
    </span>
  )
}
